import { useCallback, useEffect, useRef } from "react";

/**
 * KOMUT PALETİ KAPANINCA ODAK KAYBOLMUYOR (9 Ekim 2026, 5. tur — kabuk taraması).
 *
 * Ölçülen kusur: üst çubuktaki «Ara…» düğmesiyle (ya da ⌘K / Ctrl+K ile) açılan palet Escape ile
 * kapanınca odak `<body>`'ye düşüyor ve 2,5 sn boyunca orada kalıyordu — klavyeyle gezen kişinin
 * sonraki Tab'ı belgenin en başından («İçeriğe atla», üst çubuk, ray) başlıyordu. Kitin `Modal` ve
 * `Drawer`'ı bunu `useReturnFocusToOpener` ile çözüyor; `CommandPalette` o kancayı kullanmıyor ve
 * Radix'in kendi geri vermesi yalnız bir `Dialog.Trigger`'a odaklanıyor — paleti açan şey bir
 * tetik değil, programdan açılıyor. Kit isteği raporda; o gelene kadar kabuk bunu kendisi yapıyor.
 *
 * İKİ AYRI KAPANIŞ, İKİ AYRI YER (accessibility.md › Focus):
 *   - VAZGEÇİLDİ (Escape, dışarı tıklama): odak paleti AÇANA döner — kişi bıraktığı yerden devam
 *     eder.
 *   - BİR SONUÇ SEÇİLDİ: yeni ekran açılıyor; odak `<main>`'e gider ve sonraki Tab yeni ekranın
 *     içinden başlar. (Açana dönmek, kişiyi aradığı ekrana vardıktan sonra üst çubukta bırakırdı.)
 *     `useScreenScroll` bunu kendisi yapamıyordu: rota değiştiğinde odak hâlâ paletin arama
 *     kutusundaydı, yani «kaybolmuş» görünmüyordu — kutu bir kare sonra sökülünce kayboldu.
 *
 * Odak başka biri tarafından bilerek bir yere konduysa (gövde ya da kapanan pencere dışında bir
 * yerde) DOKUNULMUYOR — kitin kancasıyla aynı kural.
 *
 * AÇAN, AÇILIŞ ÇİZİMİNDE okunuyor (kitin kancasındaki gerekçe): etkiler çocuktan başlıyor ve
 * Radix içeriği odağı panele taşıdığında üst bileşenin etkisi daha çalışmamış oluyor.
 */
export function usePaletteFocusReturn(open: boolean): { markSelected: () => void } {
  const openerRef = useRef<HTMLElement | null>(null);
  const wasOpenRef = useRef(false);
  const selectedRef = useRef(false);

  if (open && !wasOpenRef.current) {
    const active = typeof document === "undefined" ? null : document.activeElement;
    openerRef.current = active instanceof HTMLElement && active !== document.body ? active : null;
    selectedRef.current = false;
  }
  wasOpenRef.current = open;

  useEffect(() => {
    if (open) return;
    const opener = openerRef.current;
    const selected = selectedRef.current;
    openerRef.current = null;
    selectedRef.current = false;

    const active = document.activeElement;
    const ours =
      active === null ||
      active === document.body ||
      (active instanceof HTMLElement && active.closest('[role="dialog"]') !== null);
    if (!ours) return;

    const target = selected ? document.getElementById("main") : opener;
    if (target === null || !target.isConnected) return;
    target.focus({ preventScroll: true });
  }, [open]);

  const markSelected = useCallback(() => {
    selectedRef.current = true;
  }, []);

  return { markSelected };
}
